import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessGuard } from 'src/app/core/guards/access.guard';
import { CashoutComponent } from './cashout/cashout.component';
import { PayrollComponent } from './payroll/payroll.component';
import { TipReportComponent } from './tip-report/tip-report.component';
const routes: Routes = [
  {
    path: "cashout",
    component: CashoutComponent,
    canActivate: [AccessGuard],
    data: { permissionName: 'CashoutReport', access:1 },
  },
  {
    path: "payroll",
    component: PayrollComponent,
    canActivate: [AccessGuard],
    data: { permissionName: 'PayrollReport', access:1 },
  },
  {
    path: "tip-report",
    component: TipReportComponent,
    // canActivate: [AccessGuard],
    // data: { permissionName: 'CashoutReport', access:1 },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LabourRoutingModule { }
